<template>
    <div>
        <span v-if="props.column.field == 'rule_name'">
            {{ props.row.rule_name }}
        </span>
        <span v-if="props.column.field == 'rule_detail'">
            {{ props.row.rule_detail }}
            <!-- {{ props.row.index }} -->
            <!-- {{ props.row.isLast }} -->
        </span>
        <div class="d-flex justify-content-center" v-if="props.column.field == 'status'">
            <toggle-button @change="$emit('editToggle', props.row)" sync
                :disabled="props.row._id === '65fd2bc2004c9c0defa38468'" v-model="props.row.status" />
        </div>
        <div v-else-if="props.column.field == 'actions'" class="d-flex justify-content-between">

            <feather v-if="props.row._id === '65fd2bc2004c9c0defa38468'" style="width: 20px" class="cannotMove"
                type="arrow-up">
            </feather>
            <feather v-if="props.row._id != '65fd2bc2004c9c0defa38468'" @click="
            moveUp(props.row)
            " style="width: 20px" :class="{
            cannotMove: props.row.originalIndex === 0,
            canMove: props.row.originalIndex !== 0,
        }" type="arrow-up">
            </feather>

            <!-- row down -->
            <feather v-if="props.row._id === '65fd2bc2004c9c0defa38468'" class='cannotMove' style="width: 20px"
                type="arrow-down">
            </feather>

            <feather v-if="props.row._id !== '65fd2bc2004c9c0defa38468'" @click="moveDown(props.row)" :class="{
            cannotMove: props.row.isLast,
            canMove: !props.row.isLast,
        }" style="width: 20px" type="arrow-down">
            </feather>

            <feather v-b-modal.addRule @click="editRow(props.row)"
                :disabled="props.row._id === '65fd2bc2004c9c0defa38468'" :class="{
            cannotMove: props.row._id === '65fd2bc2004c9c0defa38468',
            canMove: props.row._id !== '65fd2bc2004c9c0defa38468',
        }" style="width: 20px;" type="edit-2"></feather>
            <feather @click="$emit('deleteRow', props.row)" :class="{
            cannotMove: props.row._id === '65fd2bc2004c9c0defa38468',
            canMove: props.row._id !== '65fd2bc2004c9c0defa38468',
        }" style="width: 20px;" type="trash-2">
            </feather>
        </div>
    </div>
</template>
<script>
export default {
    name: 'datatable-row-default',
    props: {
        props: Object,
        data: Object,
    },
    data() {
        return {};
    },
    mounted() { },
    methods: {
        editRow(prop) {
            this.$emit('editRow', prop)
        },
        checkDefault(id) {
            if (id === '65fd2bc2004c9c0defa38468') {
                return 'cannotMove';
            } else {
                return 'canMove';
            }
        },
        moveDown(item) {
            if (item._id !== '65fd2bc2004c9c0defa38468' || !item.isLast) {
                item.type = 'down'
                item.oriIndex = item.originalIndex
                // console.log('down: ', item)
                this.$emit('moveRow', item)
            }
        },
        moveUp(item) {
            if (item._id !== '65fd2bc2004c9c0defa38468' || item.originalIndex === 0) {
                item.type = 'up'
                item.oriIndex = item.originalIndex
                // console.log('up: ', item)
                this.$emit('moveRow', item)
            }
            // $emit('moveRow', { type: 'up', index: props.row.originalIndex })
        },
    },
};
</script>


<style>
.cannotMove {
    opacity: 0.5 !important;
    cursor: not-allowed !important;
}

.canMove {
    opacity: 1 !important;
    cursor: pointer !important;
}
</style>
